import Container from "../../components/Container";
import DatePicker from "../../components/DatePicker";
import NeedHelpLink from "../../components/NeedHelpLink";
import PickAppointment from "../../components/PickAppointment";
import ScheduledInfluencer from "./ShcheduledInfluencer";
import ProceedButton from "../../components/ProceedButton";

const Scheduling = () => {
  return (
    <section className="bg-white pt-12">
      <Container>
        <div className="flex justify-between flex-wrap">
          <div className="scheduling xs:w-full md:w-7/12">
            <div className="date-selection">
              <div className="title text-[#e66553] font-medium text-lg m-2">
                <h2>Select Date</h2>
              </div>
              <div className="date-picker">
                <DatePicker />
              </div>
            </div>
            <div className="select-appointment">
              <div className="title text-[#e66553] font-medium text-lg m-2">
                <h2>Select Time</h2>
              </div>
              <div>
                <PickAppointment />
              </div>
            </div>
            <div className="note">
              <div className="title text-[#e66553] font-medium text-lg m-2">
                <h2>Optional Note</h2>
              </div>
              <div className="note-area">
                <textarea
                  name=""
                  id=""
                  rows="6"
                  className="w-full bg-[#f8f8f8] m-2 outline-1 outline-slate-300 p-3 text-sm placeholder:italic font-normal"
                  placeholder="Write your note here!"
                ></textarea>
              </div>
            </div>
          </div>
          <div className="xs:w-full md:w-4/12 relative">
            <div className="sticky top-0 pt-5">
              <div className="scheduled-influencer">
                <ScheduledInfluencer />
              </div>
              <div className="help">
                <NeedHelpLink />
              </div>
              <div className="proceed">
                <div className="proceed-action py-4 text-white">
                  <ProceedButton />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Scheduling;
